import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ConfirmModal } from '@feathr/components';
import { formatImportCount } from '@feathr/extender/components/ImportRunLines';

interface IOptOutConfirmModalProps {
  opened: boolean;
  isSaving: boolean;
  rowCount: number;
  onClose: () => void;
  onConfirm: () => Promise<void> | void;
}

function OptOutConfirmModal({
  opened,
  isSaving,
  rowCount,
  onClose,
  onConfirm,
}: Readonly<IOptOutConfirmModalProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <ConfirmModal
      cancelButtonText={t('Cancel')}
      confirmButtonText={t('Opt out contacts')}
      confirmButtonType={'danger'}
      confirmLoading={isSaving}
      description={t(
        'Up to {{formattedCount}} contacts will be unsubscribed from all email campaigns.',
        {
          count: rowCount,
          formattedCount: formatImportCount(rowCount),
        },
      )}
      onClose={onClose}
      onConfirm={onConfirm}
      opened={opened}
      t={t}
      title={t('Opt these contacts out?')}
    />
  );
}

export default OptOutConfirmModal;
